export default __webpack_public_path__ + "static/media/prepare.6d973de0.png";